export { default as Variant } from './Variant';
